<script>
  // @ts-check
  import { createEventDispatcher } from "svelte";
  import Checkbox from "./Checkbox.svelte";

  /** Primarily used for testing
   * @type {string | undefined} */
  export let id = undefined;

  /** The name of the checkbox group
   * @type {string} */
  export let name;

  /**
   * The label for the entire checkbox group. Used only when the checkbox group is a part of a form.
   * @type {string}
   */
  export let label;

  /** The list of checkboxes to display
   * @type {Array<{label: string; id: string; isChecked: boolean}>} */
  export let options;

  /** Indicates whether the input field is required or not.
   * @type {boolean} */
  export let required = false;

  /** The error message to display
   * @type {string | undefined} */
  export let errorMessage = "";

  export let isInvalid = false;

  /**
   * An optional CSS class to be applied to the component.
   * @type {string}
   */
  export let componentClass = "";

  const dispatch = createEventDispatcher();
  function handleChange(checkbox) {
    const { detail } = checkbox;

    options = options.map((option) => {
      if (option.id === detail.id) {
        option.isChecked = detail.value;

        if (detail.value) {
          isInvalid = false;
        }
      }
      return option;
    });

    if (required) {
      isInvalid = options.every((option) => !option.isChecked);
    }

    dispatch("checkBoxSelectionGroup", { options, name });
  }
</script>

<div
  {id}
  class={$$props.type === "multi-select"
    ? "mb-9 first-of-type:mt-9 lg:mb-10 first-of-type:lg:mt-10"
    : ""}
>
  <div
    class="flex w-full flex-col gap-6 {$$props.type === 'multi-select'
      ? 'md:gap-[30px] lg:gap-9'
      : ''} {componentClass}"
    id={name}
  >
    {#if label}
      <p class="font-gotham-condensed text-body-m-xlarge font-bold">{label}</p>
    {/if}

    {#each options as option}
      <Checkbox {...option} on:change={handleChange} />
    {/each}
  </div>

  <div id="{id}-error" class="label mt-1 text-system-red" role="alert">
    {#if isInvalid && errorMessage}
      {errorMessage}
    {:else}
      &nbsp <!-- prevent layout shift -->
    {/if}
  </div>
</div>
